/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum Uitstroom {
    INTERN = "Intern",
    INTERN_TUSSENTIJDS = "Intern (tussentijds)",
    EXTERN = "Extern",
    EXTERN_TUSSENTIJDS = "Extern (tussentijds)",
    VAVO = "VAVO",
    VAVO_TUSSENTIJDS = "VAVO (tussentijds)"
}
